import { Evidence } from '../types/player';
import { Identity } from '../types/auth';

/** JWT groups that can view confidential evidence content */
const CONFIDENTIAL_VIEWER_GROUPS = [
  'SPY_Bans_Admin',
  'SPY_Bans_Superadmins',
  'SPY_Super_admin',
];

/** Check if the current user can view confidential evidence content */
export function canViewConfidentialEvidence(identity: Identity | null): boolean {
  if (!identity) return false;
  const groups = identity.raw.custom.groups;
  return CONFIDENTIAL_VIEWER_GROUPS.some(g => groups.includes(g));
}

/**
 * Check if an evidence item's real content is inaccessible to the current user.
 *
 * Returns `true` when:
 * - The API has already redacted the content (`content_redacted === true`), OR
 * - The item is confidential and the user is not in an elevated group.
 */
export function isEvidenceRedacted(item: Evidence, identity: Identity | null): boolean {
  if (item.content_redacted) return true;
  if (item.confidential && !canViewConfidentialEvidence(identity)) return true;
  return false;
}

/** Build the evidence view/download URL */
export function getEvidenceViewUrl(id: string): string {
  return `https://spy.playcdu.co/api/notes/evidence/view/${id}`;
}
